import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../config/supabase';

export const useWebsiteContent = (page) => {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadContent = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const { data, error: fetchError } = await supabase
        .from('content_blocks')
        .select('*')
        .eq('page', page);

      if (fetchError) {
        console.error('Error loading content:', fetchError);
        setError(fetchError.message);
        setContent({});
      } else {
        // Convert array to object keyed by field_name for easy access
        const contentObj = {};
        data.forEach((block) => {
          contentObj[block.field_name] = block.content;
        });
        setContent(contentObj);
      }
    } catch (err) {
      console.error('Error loading content:', err);
      setError(err.message);
      setContent({});
    } finally {
      setLoading(false);
    }
  }, [page]);

  useEffect(() => {
    loadContent();
  }, [loadContent]);

  return { content, loading, error };
};

